module.exports = __webpack_public_path__ + "media/images/sp/icon-flag-black-453b5da303c322c124fe95390eb78ca4.png";